import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { IDashboardData, IGlobalSummary } from '../../models/Dashboard';
import { LeoService } from '../../services/leoService';
import { RootState } from '../reducers/store';

export const loadDashboard = createAsyncThunk<IDashboardData[]>(
    'dashboard/loadDashboard',
    async (a, thunkAPI) => {
        const state = thunkAPI.getState() as RootState;
        const leoService = new LeoService();
        return await leoService.GetUserStatistics();
    }
);

export const loadStatistics = createAsyncThunk<IGlobalSummary>(
    'dashboard/loadStatistics',
    async (a, thunkAPI) => {
        const state = thunkAPI.getState() as RootState;
        const leoService = new LeoService();
        return await leoService.GetGlobalStatistics();
    }
);

export const changePeriod = createAction<number>('dashboard/changePeriod');
